const letters = "abcdefghijklmnopqrstuvwxyz".split("");
const numbers = ["1", "2", "3", "4"];
const others = ["all", "11", "22", "33", "44"];
const letters2 = letters.map((letter) => letter + "1");

const all = [...letters, ...numbers, ...others];

function switchVisible(letter) {
  if (letter === "h") letter = "hh";
  // Iterate over all elements in the array
  all.forEach((item) => {
    const currentItem = item === "h" ? "hh" : item;
    // Remove the underlined letters
    const topElements = document.getElementsByClassName(currentItem + "1");
    Array.from(topElements).forEach((el) => {
      // Show the target element and hide others
      el.style.textDecorationLine = "";
    });

    const elements = document.getElementsByClassName(item);
    Array.from(elements).forEach((el) => {
      // Show the target element and hide others
      if (letter === "all") el.style.display = "block";
      else el.style.display = item === letter ? "block" : "none";
    });
  });

  // Underline the correct letter
  const topElements = document.getElementsByClassName(letter + "1");
  Array.from(topElements).forEach((el) => {
    // Show the target element and hide others
    el.style.textDecorationLine = "underline";
  });

  // Scroll to the top of the page
  window.scrollTo({ top: 0, behavior: "smooth" });
}
